export default "__VITE_ASSET__BDrlFH4O__"